module.exports = __webpack_public_path__ + "static/scale-model-of-lyndon-house-arts-center-in-athens-georgia-56b87eac67f67911c66b65d182ac77df.png";